import { CognitoConfig } from "state/CMRAuth";

const SUPPORTED_STAGES = ["dev", "prod"] as const;
type Stage = typeof SUPPORTED_STAGES[number];
type MultiStageConfig<T> = Readonly<Record<Stage, T>>;

const isValidStage = (maybeStage: unknown): maybeStage is Stage =>
    typeof maybeStage === "string" && (SUPPORTED_STAGES as readonly string[]).includes(maybeStage);

// ************************************************************

const COGNITO_ALL_STAGES: MultiStageConfig<CognitoConfig> = {
    dev: {
        appClientId: "66as0p4817bo7l78096g3e2je1",
        domain: "eu.authdev.cmrsurgical.com",
        region: "eu-west-2",
        userPoolId: "eu-west-2_FP6H5TPZe",
    },
    prod: {
        appClientId: "1nttpa5qegimeg6c1s8e8j4tuj",
        domain: "eu.auth.cmrsurgical.com",
        region: "eu-west-2",
        userPoolId: "eu-west-2_mQiFbuxB0",
    },
};

// ************************************************************

type LoggingConfig = {
    sumoLogicEndpoint: string;
};

const LOGGING_ALL_STAGES: MultiStageConfig<LoggingConfig> = {
    dev: {
        sumoLogicEndpoint:
            "https://endpoint1.collection.eu.sumologic.com/receiver/v1/http/ZaVnC4dhaV2rlVzzlh2uKEfvDUcWhRmcOS8ArRJBvP6ZsfqC03635ab_vEinbcq36F7qd-L8yS0pwolGKm81Zg-Or1mulbbtiWOyUvoe_1AE0O6SYi5yLA==",
    },
    // prod: {
    //     sumoLogicEndpoint:
    //         "https://endpoint1.collection.eu.sumologic.com/receiver/v1/http/ZaVnC4dhaV3xMv_ycQpuhauU8Q4w8XSg-lkLfUiB7SmfbaSToSvI3eGQeXk_kvnuTl8h_QefysDPJwJaZnXG7pnxXuUl4pbEyCy5HHwp64GIihUK0K3Ugw==",
    // },
    prod: {
        sumoLogicEndpoint: "",
    },
};

// ************************************************************

type SurgeryServiceConfig = {
    baseUrl: string;
};

const SURGERY_SERVICE_ALL_STAGES: MultiStageConfig<SurgeryServiceConfig> = {
    dev: {
        baseUrl: "https://surgeries.api.aldev.cmrsurgical.com",
    },
    prod: {
        baseUrl: "https://surgeries.api.cmrsurgical.com",
    },
};

// ************************************************************

if (process.env.REACT_APP_STAGE && !isValidStage(process.env.REACT_APP_STAGE))
    throw new Error(
        `Invalid value for environment variable REACT_APP_STAGE: ${process.env.REACT_APP_STAGE} - must be one of ${SUPPORTED_STAGES}`
    );

export const STAGE: Stage = (process.env.REACT_APP_STAGE as Stage) || "dev";

export const COGNITO = COGNITO_ALL_STAGES[STAGE];
export const LOGGING = LOGGING_ALL_STAGES[STAGE];
export const SURGERY_SERVICE = SURGERY_SERVICE_ALL_STAGES[STAGE];

// Also default export a combined config for convenience
export default {
    COGNITO,
    LOGGING,
};
